// extracted by mini-css-extract-plugin
export default {"page":"PageLayout_page__ebi3B","content":"PageLayout_content__PJlNQ","title":"PageLayout_title__-y213"};